import { render, staticRenderFns } from "./ExtratoDialog.vue?vue&type=template&id=3ca94484"
import script from "./ExtratoDialog.vue?vue&type=script&lang=js"
export * from "./ExtratoDialog.vue?vue&type=script&lang=js"
import style0 from "./ExtratoDialog.vue?vue&type=style&index=0&id=3ca94484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports